import {
    IProps,
} from './types';

import classNames from 'classnames';
import React, {
    FC,
    useRef,
    useState,
} from 'react';

import {
    useClickOutside,
} from 'tools/hooks';

import StringInput from '../StringInput';

import {
    MAX_SUGGESTIONS_COUNT,
} from './constants';

import styles from './AutoSuggestInput.module.scss';

const AutoSuggestInput: FC<IProps> = (props) => {
    const [isOpen, setIsOpen] = useState(false);

    const containerRef = useRef<HTMLDivElement>(null);

    const onChangeInputValue = (inputValue: string) => {
        props.onChangeInputValue?.(inputValue);

        const value = props.values.find((value) =>
            value.toLocaleLowerCase() === inputValue.toLocaleLowerCase()
        );

        props.onChangeValue?.(value ?? inputValue);
    };
    const onSelectValue = (value: string) => {
        props.onChangeInputValue?.(value);
        props.onChangeValue?.(value);
        setIsOpen(false);
    };

    useClickOutside(containerRef, () => {
        setIsOpen(false);
    });

    return (
        <div
            ref={containerRef}
            className={classNames(styles.autoSuggestInput, props.className)}
        >
            <StringInput
                size={props.size}
                label={props.label}
                placeholder={props.placeholder}
                value={props.inputValue}
                isDisabled={props.isDisabled}
                isError={props.isError}
                errorMessage={props.errorMessage}
                onChangeValue={onChangeInputValue}
                onFocus={() => setIsOpen(true)}
            />
            {
                isOpen &&
                !props.isDisabled &&
                !!props.values.length &&
                <div className={styles.options}>
                    {
                        props.values
                            .slice(0, props.maxSuggestionsCount ?? MAX_SUGGESTIONS_COUNT)
                            .map(
                                (value) =>
                                    <div
                                        key={value}
                                        className={styles.option}
                                        onClick={() => onSelectValue(value)}
                                    >
                                        {value}
                                    </div>
                            )
                    }
                </div>
            }
        </div>
    );
};

export default AutoSuggestInput;
